import PayOverTimeStatementsScreen from 'features/payOverTime/screens/PayOverTimeStatements/PayOverTimeStatementsScreen';

export default function PayOverTimeStatementsPage() {
  return <PayOverTimeStatementsScreen />;
}
